import axios from "axios";
import { API_URL, authHeader } from "./api";

const endpoint = API_URL + "hotel/integrations/schlage/";
// Pin each request to the property displayed when the operation started.
const options = (hotelId) => ({
  headers: { ...authHeader(), "x-hotel-id": hotelId },
});
const SchlageService = {
  status: (hotelId) => axios.get(endpoint + "status", options(hotelId)),
  devices: (hotelId) => axios.get(endpoint + "devices", options(hotelId)),
  authorize: (hotelId) =>
    axios.post(endpoint + "authorize-url", {}, options(hotelId)),
  map: (hotelId, doorId, deviceId, replacement = {}) =>
    axios.post(
      endpoint + "device",
      { doorId, deviceId, ...replacement },
      options(hotelId),
    ),
};

export default SchlageService;
